import { getPageSource, track } from '@mc/track-event'

const EVENT_NAME = 'Plans Page Row Viewed'

export const trackFreeGiftMembershipRowViewed = () =>
  track(EVENT_NAME, {
    category: 'pricing matrix',
    row: 'free_gift_membership',
    row_name: 'free_gift_membership',
    row_position_index: 4,
    page_source: getPageSource(),
  })
